import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  height: 60px;\n  padding: 0 20px;\n  transition: opacity 200ms;\n\n  &:hover {\n    opacity: 0.7;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: ", ";\n  left: 0;\n  list-style: none;\n  margin: 0;\n  max-height: 273px;\n  overflow: scroll;\n  padding: 0;\n  width: 100%;\n  z-index: 9999;\n\n  li:not(:last-child) {\n    border-bottom: 1px solid #f5f5f5;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, withHandlers } from 'recompose';
import { theme } from '../../../theme';
import styled from '../../../utils/styling/styled-components';
import withClickOutside from './withClickOutside';
var enhance = compose(withHandlers({
  handleSuggestionClick: function handleSuggestionClick(_ref) {
    var onSelect = _ref.onSelect,
        suggestions = _ref.suggestions;
    return function (_ref2) {
      var target = _ref2.target;
      onSelect(suggestions[target.dataset.index]);
    };
  }
}), withClickOutside(function (_ref3) {
  var onClickOutside = _ref3.onClickOutside;
  onClickOutside(false);
}));
var List = styled.ul(_templateObject(), theme.shadows.lgMedium);
var ListItem = styled.li(_templateObject2());
var AddressAutoCompleteList = enhance(function (_ref4) {
  var handleSuggestionClick = _ref4.handleSuggestionClick,
      suggestions = _ref4.suggestions;
  return /*#__PURE__*/React.createElement(List, null, suggestions.map(function (suggestion, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: suggestion.place_id,
      onClick: handleSuggestionClick,
      "data-index": index,
      tabIndex: 0,
      role: "listitem"
    }, suggestion.description);
  }));
});
export default AddressAutoCompleteList;